import {
  ADDPRODUCT,
  PRODUCTDECREMENT,
  PRODUCTINCREMENT,
  PRODUCTREMOVED,
} from "./actionTypes";
import initialState from "./initialState";

const getMaxId = (state) => {
  return state.reduce((prevId, currentElement) => {
    return Math.max(prevId, currentElement.id);
  }, -1);
};

const productReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADDPRODUCT:
      return [
        ...state,
        {
          id: getMaxId(state) + 1,
          productName: action.payload.productName,
          category: action.payload.category,
          imgUrl: action.payload.imgUrl,
          price: action.payload.price,
          quantity: action.payload.quantity,
          stock: action.payload.stock,
        },
      ];
    case PRODUCTDECREMENT:
      return state.map((product) => {
        if (action.payload.id === product.id) {
          return {
            ...product,
            quantity: product.quantity > 0 ? product.quantity - 1 : 0,
          };
        } else {
          return { ...product };
        }
      });
    case PRODUCTINCREMENT:
      return state.map((product) => {
        if (action.payload.id === product.id) {
          return {
            ...product,
            quantity:
              product.quantity < product.stock
                ? product.quantity + 1
                : product.stock,
          };
        } else {
          return { ...product };
        }
      });

    case PRODUCTREMOVED:
      return state.map((product) => {
        if (action.payload.id === product.id) {
          return {
            ...product,
            quantity: product.stock,
          };
        } else {
          return { ...product };
        }
      });

    default:
      return [...state];
  }
};
export default productReducer;
